import React, { useState, forwardRef } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a toggle-visibility eye icon.
 * Usage:
 *   <PasswordInput value={pwd} onChange={...} data-testid="..." />
 *
 * The eye button lives inside the input on the LEFT side (RTL page) so the
 * cursor/text still flows naturally. A dedicated data-testid is exposed on the
 * toggle button for reliable E2E tests.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", ...props },
  ref
) {
  const [show, setShow] = useState(false);
  const testId = props["data-testid"];

  return (
    <div className="relative">
      <Input
        {...props}
        ref={ref}
        type={show ? "text" : "password"}
        className={`pe-10 ${className}`}
        dir="ltr"
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        className="absolute top-1/2 -translate-y-1/2 text-[#0A4D3C] hover:text-[#063A2D] focus:outline-none focus:ring-2 focus:ring-[#E5E1D8] rounded-full p-1 transition-colors"
        style={{ insetInlineEnd: "0.5rem" }}
        tabIndex={-1}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
